import React from 'react';
import { Box, Typography, useWindowSize } from 'vindi-ds-components';
import styles from './styles';

function HeaderTitle({ children }) {
  const windowSize = useWindowSize();
  const { isMobile } = windowSize;

  return (
    <Box css={styles.title}>
      <Typography variant={isMobile ? 'subtitle1' : 'h5'} component='h1'>
        {children}
      </Typography>
    </Box>
  );
}

export default HeaderTitle;
